{
  "imports.title": "Import data",
  "imports.lede": "Map a private export, inspect every proposed record, then apply only what you choose.",
  "imports.navigation.label": "Import data",
  "imports.navigation.hint": "Review and apply bounded exports from other tools.",
  "imports.error.generic": "The import could not be completed.",
  "imports.error.preserved": "Nothing new was applied. Your current work remains on this page.",
  "imports.error.fileTooLarge": "Choose a file no larger than {{size}} MB.",
  "imports.state.draft": "Draft",
  "imports.state.needs_input": "Needs input",
  "imports.state.partially_applied": "Partially applied",
  "imports.state.applied": "Applied",
  "imports.state.rejected": "Rejected",
  "imports.state.expired": "Expired",
  "imports.state.superseded": "Superseded",
  "imports.state.pending": "Pending",
  "imports.state.accepted": "Accepted",
  "imports.family.markdown": "Markdown",
  "imports.family.obsidian": "Obsidian",
  "imports.family.csv": "CSV",
  "imports.family.json": "JSON",
  "imports.family.todoist": "Todoist",
  "imports.family.things": "Things",
  "imports.family.ticktick": "TickTick",
  "imports.family.notion": "Notion",
  "imports.family.apple_health": "Apple Health",
  "imports.family.google_takeout": "Google Takeout",
  "imports.entity.project": "Project",
  "imports.entity.goal": "Goal",
  "imports.entity.decision": "Decision",
  "imports.entity.task": "Task",
  "imports.entity.plan": "Plan",
  "imports.entity.period": "Period",
  "imports.entity.routine": "Routine",
  "imports.entity.note": "Note",
  "imports.entity.knowledge_item": "Knowledge item",
  "imports.entity.journal_entry": "Journal entry",
  "imports.entity.life_item": "Life record",
  "imports.entity.calendar_block": "Calendar block",
  "imports.source.title": "Source",
  "imports.source.description": "The file stays owner-scoped. Preview reads at most the record limit below.",
  "imports.source.family": "Source type",
  "imports.source.file": "Export file",
  "imports.source.fileHint": "UTF-8 text or a supported export archive, up to {{size}} MB.",
  "imports.source.recordPath": "Record path",
  "imports.source.recordPathHint": "Optional RFC 6901 pointer to the JSON array, for example /items.",
  "imports.source.delimiter": "Delimiter",
  "imports.source.comma": "Comma",
  "imports.source.semicolon": "Semicolon",
  "imports.source.tab": "Tab",
  "imports.source.maxRecords": "Maximum records",
  "imports.source.maxRecordsHint": "One preview can include at most {{count}} records.",
  "imports.placeholder.recordPath": "/items",
  "imports.placeholder.sourcePath": "/CONTENT",
  "imports.placeholder.titlePath": "/title",
  "imports.placeholder.constantPath": "/priority",
  "imports.target.title": "Destination",
  "imports.target.description": "Choose one canonical record type. IDs and ownership are always assigned by the server.",
  "imports.target.entity": "Record type",
  "imports.target.lifeSchema": "Life schema ID",
  "imports.target.lifeSchemaHint": "Life records require an existing schema that belongs to you.",
  "imports.mapping.title": "Field mapping",
  "imports.mapping.description": "Use JSON pointers for source and destination fields. Imported values are treated only as data.",
  "imports.mapping.sourcePath": "Source path {{number}}",
  "imports.mapping.targetPath": "Destination path {{number}}",
  "imports.mapping.transform": "Transform",
  "imports.mapping.removeBinding": "Remove mapping {{number}}",
  "imports.mapping.required": "Required source value",
  "imports.mapping.default": "Use a default when missing",
  "imports.mapping.defaultValue": "Default value",
  "imports.mapping.jsonValueHint": "Enter JSON for numbers, booleans, arrays or objects; other text remains a string.",
  "imports.mapping.addBinding": "Add field",
  "imports.mapping.addConstant": "Add constant",
  "imports.constants.title": "Constants",
  "imports.constants.targetPath": "Constant destination {{number}}",
  "imports.constants.value": "Constant value {{number}}",
  "imports.constants.remove": "Remove constant {{number}}",
  "imports.transform.identity": "Keep as-is",
  "imports.transform.string": "Text",
  "imports.transform.trim": "Trimmed text",
  "imports.transform.integer": "Integer",
  "imports.transform.number": "Number",
  "imports.transform.boolean": "True or false",
  "imports.transform.date": "Date",
  "imports.transform.datetime": "Date and time",
  "imports.transform.string_list": "Text list",
  "imports.preview.action": "Upload and preview",
  "imports.review.title": "Import review",
  "imports.review.description": "The preview has not written target records. Read each source excerpt as untrusted imported text.",
  "imports.review.file": "File",
  "imports.review.records": "Records",
  "imports.review.target": "Destination",
  "imports.review.status": "Status",
  "imports.review.validation": "{{count}} canonical operation(s) passed the preview validation.",
  "imports.status.refresh": "Refresh status",
  "imports.new": "New import",
  "imports.records.title": "Proposed records",
  "imports.records.description": "Select rows to apply or reject them permanently from this proposal.",
  "imports.record.selected": "Selected",
  "imports.record.accept": "Accept",
  "imports.record.accepted": "Accepted",
  "imports.record.reject": "Reject",
  "imports.dryRun.complete": "Dry run passed for {{count}} operation(s). No target records were written.",
  "imports.dryRun.action": "Dry run selected",
  "imports.apply.complete": "Applied {{count}} operation(s) as one reversible receipt.",
  "imports.apply.action": "Apply selected",
  "imports.operation.queue": "Queue selected",
  "imports.operation.cancel": "Cancel queued import",
  "imports.operation.progress": "{{current}} of {{total}} complete · {{percent}}%",
  "imports.operation.progressLabel": "Queued import progress",
  "imports.operation.state.pending": "Import queued",
  "imports.operation.state.running": "Import is committing",
  "imports.operation.state.cancel_requested": "Cancellation requested",
  "imports.operation.state.cancelled": "Queued import cancelled",
  "imports.operation.state.succeeded": "Import completed",
  "imports.operation.state.failed": "Import failed safely",
  "imports.operation.failed": "The worker returned {{code}}. No private source content was stored in this status.",
  "imports.undo.complete": "The applied import was undone as one scope.",
  "imports.undo.action": "Undo import",
  "imports.selection.summary": "{{selected}} selected · {{pending}} pending"
}
